/**
 * Where the web client finds the London map and the API (TASK-986: the
 * client is v2-only; `/api/v1` stays on the backend for old app versions).
 *
 * The map set lives under its own path, `public/map-v2/` (import with
 * `scripts/import-map-bundle-v2.sh`), not at the old v1 root names: a tab
 * still running a pre-v2 bundle then fails to load the map and shows the
 * reload screen instead of reading v2 data with a v1 parser.
 */
export const MAP_SET_PATH = '/map-v2'

/** API path prefix — the version lives in the path, the city in the host. */
export const API_PREFIX = '/api/v2'

/** Same-origin URL of a map file (`schema.json`, `connections-dark.mmtg`, …). */
export function mapAssetUrl(name: string): string {
  return `${MAP_SET_PATH}/${name}`
}
